import { Square, Bath, Car, Ratio } from "lucide-react";

interface PropertySpecsProps {
  size?: number;
  sizeUnit?: string;
  landSize?: number;
  landSizeUnit?: string;
  bathrooms?: number;
  parkingSpaces?: number;
}

const PropertySpecs = ({
  size,
  sizeUnit = "sqft",
  landSize,
  landSizeUnit = "Perch",
  bathrooms,
  parkingSpaces,
}: PropertySpecsProps) => {
  return (
    <div className="bg-gray-50 px-6 py-4 flex flex-wrap justify-center md:justify-start gap-8 border-b border-gray-200">
      {/* Land Size */}
      {landSize && (
        <div className="flex items-center">
          <div className="bg-blue-100 p-2 rounded-full mr-3">
            <Ratio className="h-5 w-5 text-blue-700" />
          </div>
          <div className="flex flex-col">
            <span className="text-sm text-gray-500">Land Size</span>
            <span className="font-semibold text-gray-900">
              {landSize.toLocaleString()} {landSizeUnit}
            </span>
          </div>
        </div>
      )}
      {/* Floor Size */}
      {size && (
        <div className="flex items-center">
          <div className="bg-blue-100 p-2 rounded-full mr-3">
            <Square className="h-5 w-5 text-blue-700" />
          </div>
          <div className="flex flex-col">
            <span className="text-sm text-gray-500">Floor Size</span>
            <span className="font-semibold text-gray-900">
              {size.toLocaleString()} {sizeUnit}
            </span>
          </div>
        </div>
      )}

      {/* Bathrooms */}
      {bathrooms && bathrooms > 0 && (
        <div className="flex items-center">
          <div className="bg-blue-100 p-2 rounded-full mr-3">
            <Bath className="h-5 w-5 text-blue-700" />
          </div>
          <div className="flex flex-col">
            <span className="text-sm text-gray-500">Bathrooms</span>
            <span className="font-semibold text-gray-900">{bathrooms}</span>
          </div>
        </div>
      )}

      {/* Parking */}
      {parkingSpaces && parkingSpaces > 0 && (
        <div className="flex items-center">
          <div className="bg-blue-100 p-2 rounded-full mr-3">
            <Car className="h-5 w-5 text-blue-700" />
          </div>
          <div className="flex flex-col">
            <span className="text-sm text-gray-500">Parking</span>
            <span className="font-semibold text-gray-900">
              {parkingSpaces} Spaces
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default PropertySpecs;
